import { INTERNAL_NETWORK_ONLY_CODE } from './internalNetworkError';
import { MATERIAL_DOWNLOAD_INTERNAL_ONLY } from '../constants/accessMessages';

/**
 * Content-Dispositionヘッダーからファイル名を抽出する（videoDownload.ts と同じロジック）
 */
const parseFileNameFromContentDisposition = (contentDisposition: string | undefined): string | null => {
  if (!contentDisposition) {
    return null;
  }
  const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  if (fileNameMatch && fileNameMatch[1]) {
    return decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''));
  }
  return null;
};

/**
 * 資料の原本を保存する（元のファイルを保存ボタン）。
 * 動画のダウンロードと同じく院内ネットワークからのみ許可され、院外だと
 * 403 + code: 'INTERNAL_NETWORK_ONLY' が返る。その場合は専用メッセージを表示する。
 */
export const downloadVideoMaterialOriginal = async (
  materialId: number,
  token: string,
  defaultFileName: string,
  onSuccess?: () => void,
  onError?: (error: string) => void
): Promise<void> => {
  if (!token || !materialId) {
    onError?.('保存に失敗しました：認証情報がありません');
    return;
  }

  try {
    const response = await fetch(`/api/video-materials/${materialId}/download`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      let errorMessage = '資料の保存に失敗しました';
      try {
        const errorData = await response.json();
        if (response.status === 403 && errorData.code === INTERNAL_NETWORK_ONLY_CODE) {
          errorMessage = MATERIAL_DOWNLOAD_INTERNAL_ONLY;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        }
      } catch {
        // JSONでない場合はデフォルトメッセージ
      }
      onError?.(errorMessage);
      return;
    }

    const contentDisposition = response.headers.get('content-disposition');
    const fileName = parseFileNameFromContentDisposition(contentDisposition || undefined) || defaultFileName;

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    onSuccess?.();
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : '資料の保存に失敗しました';
    onError?.(errorMessage);
  }
};
